module.exports = __webpack_public_path__ + "img/WT.94fc34b9.png";